import UnlimitedLengthTrialPlaceholder from '@/shared/assets/images/unlimited-length-trial.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';

const TRIAL_PLAN_CONTENT: ModalContent = {
  title: 'Dub the whole video, not just a preview',
  bulletsHeader: '',
  buttonText: 'See plans with Unlimited length',
  content: {
    // Unlimited length is available from Creator up (Figma 6161:4508)
    allowedPlanNames: ['Creator', 'Creator Pro', 'Business'],
    chip: {
      title: 'Get full-length dubbing with other Pro tools',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'any content longer than a minute — tutorials, interviews, courses.',
    },
    selectedPlan: 'Creator',
    whatYouCanDo: {
      title: 'With Unlimited length:',
      bullets: [
        'Your full video, fully dubbed and ready to publish',
        'No content cut to fit a time limit',
        'Every word, every speaker, to the very end',
      ],
    },
  },
  features: [],
  media: {
    src: UnlimitedLengthTrialPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: () => MixpanelEvents.trialFeatureUpsellModalUnlockClick({ feature: 'unlimitedLength' }),
  mixpanelOpeningEvent: () => MixpanelEvents.trialFeatureUpsellModalShown({ feature: 'unlimitedLength' }),
  subtitle: 'Your trial previews 1 minute. On a paid plan, Rask dubs the entire file — nothing cut, nothing missing.',
};

export const UNLIMITED_LENGTH_CONTENT: LimitedFeatureContent = {
  trial: TRIAL_PLAN_CONTENT,
};
